export default {
  MULTIPLE_CHOICE_LETTERS: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
};
